import { useMemo, useState } from "react";

import { Modal } from "@componentes-mu/componentes-mu";

import { usePriorityTicketsAtendimento, useAddTicketPriority } from "../../../services/tickets/useTickets";
import { useAuth } from "../../../contexts/AuthContext";
import { NotFound } from "../../../components/NotFound";
import { LoadingOverlay } from "../../../components/Loading";
import { ModalPriority } from "./ModalPriority";
import { PriorityTicketResponse } from "../../../types/tickets/types";
import { useShowNotification } from "../../../hooks/useShowNotificationContext";


export type ModalPriorityContainerProps = {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
}


export const ModalPriorityContainer = ({ isOpen, onClose, onConfirm }: ModalPriorityContainerProps) => {
    const { oidCliente } = useAuth()

    const [isDragging, setIsDragging] = useState(false);

    const { showSucessNotification, showErrorNotification } = useShowNotification()

    const { data, refetch: atendimentoRefetch,
        isLoading: atendimentoLoading, isError: atendimentoError,
        error: atendimentoErrorData } = usePriorityTicketsAtendimento(
            oidCliente!,
            {
                enabled: !!oidCliente,
            }
        );


    const addTicketPriority = useAddTicketPriority();

    const isLoading = atendimentoLoading
    const isError = atendimentoError
    const error = atendimentoErrorData

    const onConfirmPriority = (tickets: PriorityTicketResponse[]) => {
        if (!oidCliente) return;

        addTicketPriority.mutate({
            oidCliente: oidCliente,
            prioridades: tickets.map((ticket) => ({
                ticket: ticket.ticket,
                ordem: ticket.prioridadeCliente || 0,
            }))
        }, {
            onSuccess: () => {
                showSucessNotification("Prioridade atualizada com sucesso!");
                onConfirm();
            },
            onError: (e) => {
                showErrorNotification(e, 'Falha ao atualizar a prioridade: verifique os dados e tente novamente.');
            },
        },
        )
    }

    const filteredData = useMemo(() => {
        if (!data) return [];

        return isDragging
            ? data.filter(item => item.prioridadeCliente != null)
            : data;
    }, [data, isDragging]);

    if (!filteredData.length) return null;

    return (
        <>
            {isError ? (
                <NotFound
                    error={error}
                    defaultMessage={'Erro ao carregar a lista de prioridade de tickets.'}
                    retry={atendimentoRefetch}
                />
            )
                :
                (
                    <>
                        {isLoading && <LoadingOverlay />}

                        {data && <Modal
                            style={{ width: "85vw", maxWidth: "1200px" }}
                            isOpen={isOpen}
                            onClose={onClose}
                        >

                            <ModalPriority
                                data={filteredData}
                                isDragging={isDragging}
                                onClose={onClose}
                                onConfirm={onConfirmPriority}
                                handleOption={(isDragging) => setIsDragging(isDragging)}
                            />


                        </Modal>}

                    </>
                )
            }
        </>

    )
}